import { render, staticRenderFns } from "./indexOnlyYL.vue?vue&type=template&id=79b0c2ca&scoped=true"
import script from "./indexOnlyYL.vue?vue&type=script&lang=js"
export * from "./indexOnlyYL.vue?vue&type=script&lang=js"
import style0 from "./indexOnlyYL.vue?vue&type=style&index=0&id=79b0c2ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0c2ca",
  null
  
)

export default component.exports